import api from '../../utils/api'

import { useEffect, useState } from 'react'

/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormProcedure from './Form/FormProcedure'

function EditProcedure({ id, btCancelAction, handleOnSuccess }) {
    const [procedure, setProcedure] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')

    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {
        api.get(`/procedure/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            setProcedure(response.data.procedure)
        })
    }, [token, id])

    async function updateProcedure(procedure) {
        let msgType = 'success'

        const data = await api.patch(`procedure/update/${procedure._id}`, procedure, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            return response.data
        }).catch((err) => {
            msgType = 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error') {
            handleOnSuccess()
        }
    }

    return (
        <section>
            {procedure._id && (
                <FormProcedure
                    title="Editar Procedimento"
                    handleSubmit={updateProcedure}
                    btnText="Salvar"
                    btCancelAction={btCancelAction}
                    procedureData={procedure}
                />
            )}
        </section>
    )
}

export default EditProcedure
